import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { createGlobalReferenceContext } from '../../utils/createGlobalReferenceContext.mjs';

const LocaleContext = createGlobalReferenceContext("fx-locale-context", null);
function LinearLocaleProvider({
  locale,
  children
}) {
  return /* @__PURE__ */ jsx(LocaleContext.Provider, { value: { locale }, children });
}
function useLinearLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error("LocaleProvider \uC548\uCABD\uC5D0\uC11C \uC0AC\uC6A9\uD574 \uC8FC\uC138\uC694");
  }
  return context;
}

export { LocaleContext, LinearLocaleProvider as default, useLinearLocale };
//# sourceMappingURL=LocaleContext.mjs.map
